module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.autodestroy) ? _c('div', {
    staticClass: "notif-bar row",
    class: _vm.type
  }, [_c('div', {
    staticClass: "sprt"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.autodestroy = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-close"
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-bandeau-alert"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d7ad7b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/notif-bar.vue
// module id = 1109
// module chunks = 0